import React from 'react';
import { Landolt } from './landolt';
import { ConfigTitle } from '../../screen-config/views/config-title';
import { ConfigTextBottom } from '../../screen-config/views/config-text-bottom';
import { VidebisButton } from '../../shared/components/videbis-button/videbis-button';
import '../styles/test-explanation.scss';
import { ConfigTextMiddle } from '../../screen-config/views/config-text-middle';


interface Props {
	src?: string;
	onPress: () => void;
	onBack: () => void;

}

export const EyeTestExplanation: React.FunctionComponent<Props> = props => {
	return (
		<section className={'limit-width'}>
			<ConfigTitle
				title={'Sehtest 1: Sehschärfe'}
				subtitle={'Wo ist die Öffnung des Rings?'} />

			<div className={'test-explanation__landolt-ex'}>
				<Landolt direction={8} baseSize={80} scaleFactor={1} />
			</div>

			<ConfigTextMiddle
				textLeft={
					'Nutzen Sie die Buttons oder Ihren Ziffernblock, um die Richtung anzugeben.'
				}
				textRight={
					'Unsicher? Um die Aufgabe zu überspringen, klicken Sie in die Mitte des Ringes oder am Ziffernblock.'}
			/>

			<ConfigTextBottom
				textBottom={
					'Warnung: Um den Ziffernblock nutzen zu können, muss die Num-Feststelltaste aktiviert sein.'
				} />


			<div className={'test-explanation__buttons'}>
				<VidebisButton
					onPress={props.onBack}
					text={'Zurück'}
					bgColor={'#ffffff'}
					txtColor={'#0c23fb'} />
				<div className={'test-explanation__start-button'}>
					<VidebisButton onPress={props.onPress} text={'Starten!'} />
				</div>
			</div>

		</section>
	);
};
